module.exports = __webpack_public_path__ + "static/eif-logo-43e5801751f8a7e301e0bc4dfdd97e97.jpg";